var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyStoriesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8946 5.49841V22.4304C17.8946 22.9632 17.4578 23.4 16.925 23.4H3.25943C1.51223 23.4 0.105835 22.236 0.105835 20.7312V3.75361C0.105835 2.00641 1.75463 0.600006 3.84263 0.600006H13.4786C14.0138 0.600006 14.4506 1.03681 14.4506 1.56961V19.0344C14.4506 19.5672 14.0138 20.004 13.4786 20.004H3.25943C2.53223 20.004 1.99703 20.3928 1.99703 20.7816C1.99703 21.12 2.53223 21.5568 3.25943 21.5568H15.953V5.54881C15.953 5.01361 16.3898 4.57681 16.925 4.57681C17.4578 4.57681 17.8466 4.96561 17.8946 5.49841Z",
    fill: "#3180F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyStoriesIcon);
export default __webpack_public_path__ + "static/media/my_stories_icon.116923cd2b41e31bacbaeb7100798e09.svg";
export { ForwardRef as ReactComponent };